module.exports = __webpack_public_path__ + "producr-dried fresh-grass-21.jpg?6b27a429c296601eccbec2eb2b7e1e42";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-21.jpg
// module id = 79
// module chunks = 0